<template>
    <div id="page-steppers">
        <v-container grid-list-xl fluid>
            <v-layout row wrap>
                <v-flex sm12>
                    <v-subheader> سفارش خدمات</v-subheader>
                    <v-stepper v-model="step">
                        <v-stepper-header>
                            <v-stepper-step step="1" :complete="step > 1">انتخاب خدمات</v-stepper-step>
                            <v-divider></v-divider>
                            <v-stepper-step step="2" :complete="step > 2">پیکره بندی</v-stepper-step>
                            <v-divider></v-divider>
                            <v-stepper-step step="3">توضیحات و تایید</v-stepper-step>
                        </v-stepper-header>
                        <v-stepper-items>
                            <v-stepper-content step="1">
                                <v-layout>
                                    <v-flex xs10>
                                        <v-autocomplete
                                                label="سرویس مورد نظر"
                                                :items="services"
                                                v-model="form.sid"
                                                autocomplete
                                                menu-props="auto"
                                                required
                                                item-text="service_title"
                                                item-value="sid"
                                        ></v-autocomplete>
                                    </v-flex>
                                    <v-flex xs2 class="pt-3">
                                        <v-btn color="primary" @click.native="getFields()">ادامه
                                        <v-icon>arrow_back</v-icon>
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-stepper-content>
                            <v-stepper-content step="2">
                                <v-container>
                                    <v-form ref="form_data">
                                    <v-layout>
                                        <v-flex class="text-xs-center">
                                            <v-chip color="secondary" text-color="white">قیمت واحد: {{(this.form.unit_price)}} ریال</v-chip>
                                            ×
                                            <v-chip>
                                                <v-text-field
                                                        :label="this.selected_service.unit"
                                                        type="number"
                                                        data-number
                                                        v-model.number="form.quantity"
                                                        @change="validateQuantity"
                                                ></v-text-field>
                                            </v-chip>
                                            =
                                            <v-chip color="green" text-color="white">قیمت کل:
                                                {{(this.form.quantity*this.form.unit_price)}} ریال

                                                ({{this.toPersian(this.form.quantity*this.form.unit_price)}})
                                            </v-chip>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout
                                            :key="ex.ex_id"
                                            v-for="(ex,_) in extra_fields_data"
                                    >
                                        <v-flex v-if="ex.type === 5">
                                            <v-divider></v-divider>
                                            <p></p>
                                            {{ex.f_name}}
                                            <input
                                                :label="ex.f_name + ':'"
                                                type="file"
                                                :ref="'extrafile_' + ex.ex_id"
                                                :required="ex.is_required === 1?'required':''"
                                                @change="processFile(ex.ex_id)"
                                            />
                                        </v-flex>
                                        <v-flex v-if="ex.type === 1">
                                            <v-text-field
                                                    :label="ex.f_name"
                                                    :name="ex.name"
                                                    type="text"
                                                    :required="ex.is_required === 1?'required':''"
                                                    v-bind:value="form.extra_fields[ex.name]['val']"
                                                    v-on:input="form.extra_fields[ex.name]['val'] = $event"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex v-if="ex.type === 2">
                                            <v-textarea
                                                    :label="ex.f_name"
                                                    :name="ex.name"
                                                    :required="ex.is_required === 1?'required':''"
                                                    v-bind:value="form.extra_fields[ex.name]['val']"
                                                    v-on:input="form.extra_fields[ex.name]['val'] = $event"
                                            ></v-textarea>
                                        </v-flex>
                                        <v-flex v-if="ex.type === 3">
                                            <v-autocomplete
                                                    :items="extra_data[ex.ex_id]"
                                                    autocomplete
                                                    item-text="val"
                                                    item-value="val"
                                                    :label="ex.f_name"
                                                    :required="ex.is_required === 1?'required':''"
                                                    v-bind:value="form.extra_fields[ex.name]['val']"
                                                    v-on:input="form.extra_fields[ex.name]['val'] = $event"
                                            ></v-autocomplete>
                                        </v-flex>
                                        <v-flex v-if="ex.type === 4">
                                            <v-autocomplete
                                                    :items="getExtraData(ex.relation_to)"
                                                    autocomplete
                                                    item-text="name"
                                                    item-value="id"
                                                    :label="ex.f_name"
                                                    :required="ex.is_required === 1?'required':''"
                                                    v-bind:value="form.extra_fields[ex.name]['val']"
                                                    v-on:input="form.extra_fields[ex.name]['val'] = $event"
                                            ></v-autocomplete>
                                        </v-flex>
                                    </v-layout>
                                    </v-form>
                                </v-container>
                                <v-btn flat @click.native="step = 1">برگشت</v-btn>
                                <v-btn color="primary" @click="goToFinal()">ادامه
                                    <v-icon>arrow_back</v-icon></v-btn>
                            </v-stepper-content>
                            <v-stepper-content step="3">
                                <v-container>
                                    <v-layout>
                                        <v-flex>
                                            تاریخ تحویل پیشنهادی
                                            <date-picker
                                                    v-model="form.delivery_date"
                                            ></date-picker>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout>
                                        <v-flex>
                                            <v-textarea
                                                    label="توضیحات"
                                                    v-model="form.res_description"
                                                    maxlength="1500"
                                            ></v-textarea>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                                <v-btn flat @click.native="step = 2">برگشت</v-btn>
                                <v-btn color="success" @click="Finalize">تکمیل سفارش
                                <v-icon>done_all</v-icon>
                                </v-btn>
                            </v-stepper-content>
                        </v-stepper-items>
                    </v-stepper>
                </v-flex>
            </v-layout>
        </v-container>
        <v-snackbar
                :bottom="snackbar.y === 'bottom'"
                :color="snackbar.color"
                :left="snackbar.x === 'left'"
                :multi-line="snackbar.mode === 'multi-line'"
                :right="snackbar.x === 'right'"
                :timeout="snackbar.timeout"
                :top="snackbar.y === 'top'"
                :vertical="snackbar.mode === 'vertical'"
                v-model="snackbar.snackbar"
        >
            {{ snackbar.text }}
            <v-btn @click.native="snackbar.snackbar = false" dark flat icon>
                <v-icon>close</v-icon>
            </v-btn>
        </v-snackbar>
    </div>
</template>

<script>
import VWidget from '@/components/VWidget';
import HttpErrorToSnackbar from '@/api/HttpErrorToSnackbar';
import VuePersianDatetimePicker from 'vue-persian-datetime-picker';

export default {
  components: {
    VWidget: VWidget,
    datePicker: VuePersianDatetimePicker
  },
  data () {
    return {
      snackbar: {
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: 'multi-line',
        timeout: 6000,
        color: 'error',
        text: ''
      },
      form: {
        sid: 1,
        quantity: 0,
        unit_price: 0,
        delivery_date: '',
        res_description: '',
        extra_fields: {}
      },
      saved: false,
      formData: {},
      services: [],
      extra_fields_data: [],
      extra_data_: {},
      selected_service: {
        unit: '',
        unit_price: 0
      },
      step: 1,
      e13: 1,
    };
  },
  watch: {
    quantity: function () {

    }
  },
  mounted: function () {
    this.axios.get('/reseller/services/')
      .then(response => {
        this.services = response.data.Data;
      })
      .catch(error => {
        // this.snackbar = HttpErrorToSnackbar(error);
      });

  },
  methods: {
    validateQuantity: function () {
      if (this.form.quantity > this.selected_service.max_quantity) {
        this.form.quantity = this.selected_service.max_quantity;
        this.snackbar.text = 'تعداد وارده از حد مجاز بیشتر است!';
        this.snackbar.color = 'error';
        this.snackbar.snackbar = true;
        return;
      }
      if (this.form.quantity < this.selected_service.min_quantity) {
        this.form.quantity = this.selected_service.min_quantity;
        this.snackbar.text = 'تعداد وارده از حد مجاز کمتر است!';
        this.snackbar.color = 'error';
        this.snackbar.snackbar = true;
        return;
      }
    },
    processFile: function (id) {
      let ref_name = 'extrafile_' + id;
      if (this.$refs[ref_name][0].files[0] !== undefined) {
        this.formData['file_' + id] = this.$refs[ref_name][0].files[0];
      }
    },
    goToFinal () {
      if (!this.$refs.form_data.validate()) {
        window.getApp.$emit('INVALID_FORM');
        return;
      }
      if (!this.ExtraCheck()) {
        return;
      }
      if (this.form.quantity > this.selected_service.max_quantity) {
        this.form.quantity = this.selected_service.max_quantity;
        this.snackbar.text = 'تعداد وارده از حد مجاز بیشتر است!';
        this.snackbar.color = 'error';
        this.snackbar.snackbar = true;
        return;
      }
      if (this.form.quantity < this.selected_service.min_quantity) {
        this.form.quantity = this.selected_service.min_quantity;
        this.snackbar.text = 'تعداد وارده از حد مجاز کمتر است!';
        this.snackbar.color = 'error';
        this.snackbar.snackbar = true;
        return;
      }
      this.step = 3;
    },
    ExtraCheck () {
      for (let i = 0; typeof this.extra_fields_data[i] !== 'undefined'; i++) {
        const v = this.extra_fields_data[i];
        if (v.is_required === 1) {
          const ex_id = v.ex_id;
          const EX_FN = v.f_name;
          for (let property in this.form.extra_fields) {
            if (this.form.extra_fields.hasOwnProperty(property)) {
              const d = this.form.extra_fields[property];
              if (d.id === ex_id && (d.val === 0 || d.val.length < 1) && v.type !== 5) {
                this.snackbar.text = 'وارد کردن ' + EX_FN + ' اجباریست.';
                this.snackbar.color = 'error';
                this.snackbar.snackbar = true;
                return false;
              }

            }
          }
        }
      }
      return true;
    },
    getExtraData: function (v) {
      return this.extra_data_[v];
    },
    getFields () {
      this.formData = {};
      this.services.forEach((v) => {
        if (v.sid === this.form.sid) {
          this.selected_service = v;
          this.form.unit_price = v.unit_price;
          this.form.quantity = this.selected_service.min_quantity;
        }
      });
      let data = [];
      this.axios.get('/reseller/service_extra_fields/?sid=' + this.form.sid)
        .then(response => {
          data = response.data.Data;
          this.step = 2;
        }).catch(error => {
          this.snackbar = HttpErrorToSnackbar(error);
        }).then(() => {
          if (data.length > 0) {
            data.forEach((v) => {
              this.form.extra_fields[v.name] = { val: v.default, id: v.ex_id };
              /**
             * Static Select
             */
              if (v.type === 3) {
                let d = v.default.split('\n');
                this.extra_data[v.ex_id] = [];
                d.forEach((dv) => {
                  this.extra_data[v.ex_id].push({ val: dv });
                });
              }
              /**
             * Dynamic Select
             */
              if (v.type === 4) {
                this.axios.get('/resellers/' + v.relation_to + '/')
                  .then(r => {
                    this.extra_data_[v.relation_to] = r.data.Data;
                  }).catch(error => {
                    this.snackbar = HttpErrorToSnackbar(error);
                  });
              }
            });
          }
          // TODO: change this trick by a standard value
          setTimeout(() => {
            this.extra_fields_data = Object.assign({}, data);
          }, 300);
        });
    },
    Finalize () {
      if (this.saved) {
        return;
      }
      let data = Object.assign({}, this.form);
      let DataForm = new FormData();
      DataForm.append('data', JSON.stringify(data));
      for (let file_name in this.formData) {
        if (this.formData.hasOwnProperty(file_name)) {
          DataForm.append(file_name, this.formData[file_name]);
        }
      }
      this.axios.post('/reseller/service_orders', DataForm, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then(response => {
          // Response Submit Method
          this.snackbar.text = 'سفارش شما با موفقیت ثبت شد و پس از بررسی کارشناسان نهایی خواهد شد.';
          this.snackbar.y = 'bottom';
          this.snackbar.color = 'success';
          this.snackbar.snackbar = true;
          this.loading = false;
          this.saved = true;
        })
        .catch(error => {
          this.snackbar = HttpErrorToSnackbar(error);
          this.loading = false;
        });

    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/service_orders/new.vue